import classNames from 'classnames';
import { useAnchorable } from '../../hooks/useAnchorable';
import type { NodeProps } from '../types';
import { blockquoteFigure, blockquoteFigureContainer } from './BlockquoteFigure.css';
import type { BlockquoteFigure } from './BlockquoteFigure.types';

export const PostBlockquoteFigure = ({ element, children, className, ...props }: NodeProps<BlockquoteFigure>) => {
  const { variant } = element.attrs;
  const { anchorAttributes } = useAnchorable(element?.attrs);

  return (
    <div {...anchorAttributes} className={classNames(className, blockquoteFigureContainer[variant])} {...props}>
      <div className={classNames(className, blockquoteFigure[variant])} {...props}>
        {children}
      </div>
    </div>
  );
};
